import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import thunk from 'redux-thunk'
import createRootReducer from '../reducers';
import {loadStore} from '../utils/store';

const composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function configureStore(initialState, history) {
    return createStore(
        createRootReducer(history),
        initialState,
        composeEnhancers(applyMiddleware(routerMiddleware(history), thunk))
    );
}

const initialState = loadStore();
const history = createBrowserHistory();
const store = configureStore(initialState, history);
window.store = store;

export {initialState, history, store}
